import { Button } from "@wags/ui/button.tsx";
import { cn } from "@wags/ui/ui-utils";

export const PROVIDER_CLAIM_VISIBLE = true;

const PROVIDER_PORTAL_ORIGIN =
    import.meta.env.VITE_VERCEL_TARGET_ENV === "production"
        ? "https://provider.wags.com"
        : "https://staging.provider.wags.com";

export function providerClaimUrl(pageId?: string) {
    const url = new URL("/claim", PROVIDER_PORTAL_ORIGIN);
    if (pageId) url.searchParams.set("pageId", pageId);
    return url.href;
}

const SURFACE_CLASS = {
    card: "rounded-card bg-havanese p-card",
    attached: "mt-4 border-t border-doberman-black/8 px-1 pt-4",
};

function ClaimEntryLayout({
    label,
    title,
    body,
    action,
    className,
    href,
}: {
    label: string;
    title: string;
    body: string;
    action: string;
    className?: string;
    href: string;
}) {
    return (
        <section
            aria-label={label}
            className={cn(
                "@container text-body text-doberman-black",
                className,
            )}
        >
            <div className="flex flex-col items-start gap-4 @min-[30rem]:flex-row @min-[30rem]:items-center @min-[30rem]:gap-6">
                <div className="flex min-w-0 flex-1 flex-col gap-1">
                    <h3 className="font-semibold text-balance">{title}</h3>
                    <p className="text-pretty break-words text-doberman-black/70">
                        {body}
                    </p>
                </div>
                <Button asChild variant="outline-ink" className="shrink-0">
                    <a href={href}>{action}</a>
                </Button>
            </div>
        </section>
    );
}

export function ProviderClaimEntryCard({
    subject,
    providerName,
    providerKind,
    surface = "card",
    className,
    href,
}: {
    subject: "page" | "listing";
    providerName?: string;
    providerKind: "breeder" | "shelter";
    surface?: keyof typeof SURFACE_CLASS;
    className?: string;
    href: string;
}) {
    const question =
        subject === "listing"
            ? "listing"
            : providerKind === "shelter"
              ? "shelter"
              : "kennel";
    return (
        <ClaimEntryLayout
            label={`Claim ${providerName ?? `this ${subject}`}`}
            title={`Is this your ${question}?`}
            body="We built this from your public info so families can find you."
            action={`Claim ${subject}`}
            className={cn(SURFACE_CLASS[surface], className)}
            href={href}
        />
    );
}

export function ProviderClaimFindPageCard({
    className,
}: {
    className?: string;
}) {
    return (
        <ClaimEntryLayout
            label="Claim your page"
            title="Run a kennel, shelter, or rescue?"
            body="You may already have a page on Wags. Claim it to keep the details accurate."
            action="Claim page"
            className={cn(SURFACE_CLASS.card, className)}
            href={providerClaimUrl()}
        />
    );
}
